export type ColumnSlug = "star" | "variety" | "crew" | "schedule";

export interface Column {
  slug: ColumnSlug;
  name: string;
  short: string;
  desc: string;
  accent: string;
  icon: string;
}

export interface Article {
  id: string;
  column: ColumnSlug;
  title: string;
  excerpt: string;
  tag: string;
  author: string;
  date: string;
  readMin: number;
  views: string;
  image: string;
  hot?: number;
  lead: string;
  content: string[];
  related: string[];
}

export const columns: Column[] = [
  {
    slug: "star",
    name: "明星动态",
    short: "明星",
    desc: "一线明星真实动态、红毯现场、商务官宣与幕后点滴，看偶像台前幕后每一面。",
    accent: "#d8433b",
    icon: "ri-star-smile-line",
  },
  {
    slug: "variety",
    name: "综艺内幕",
    short: "综艺",
    desc: "热门综艺录制内幕、嘉宾同框互动、幕后花絮与未播画面，揭秘节目台前幕后。",
    accent: "#2e7d43",
    icon: "ri-mic-line",
  },
  {
    slug: "crew",
    name: "剧组消息",
    short: "剧组",
    desc: "在拍剧综未播花絮、开机定档、路透与片场趣闻，一手掌握剧组最新动态。",
    accent: "#c58a00",
    icon: "ri-movie-line",
  },
  {
    slug: "schedule",
    name: "艺人行程",
    short: "行程",
    desc: "艺人通告排期、机场接机、线下见面会与活动预告，准时追星的日程表。",
    accent: "#8a5bd6",
    icon: "ri-calendar-check-line",
  },
];

export const columnMap: Record<ColumnSlug, Column> = Object.fromEntries(
  columns.map((c) => [c.slug, c]),
) as Record<ColumnSlug, Column>;

export const articles: Article[] = [
  {
    id: "baoliao-2026-0906-01",
    column: "star",
    title: "顶流小生深夜收工被拍，素颜状态好到网友直呼'太能打了'",
    excerpt: "一场红毯、三个热搜。近日某顶流小生在结束品牌活动后于深夜被镜头捕捉，状态与口碑再度引发热议。",
    tag: "独家",
    author: "98编辑部",
    date: "09-06 08:20",
    readMin: 4,
    views: "32.7万",
    hot: 1,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20portrait%20of%20a%20handsome%20young%20male%20celebrity%20in%20sharp%20tailored%20black%20suit%2C%20dim%20backstage%20corridor%20with%20warm%20spotlight%20glow%2C%20candid%20mid%20stride%20motion%2C%20cinematic%20magazine%20cover%20style%2C%20soft%20bokeh%20background%2C%20high%20detail%2C%20editorial%20glamour&width=900&height=620&seq=star-01-2026&orientation=landscape",
    lead: "凌晨两点的停车场，镜头扫过一道修长的身影。没有刻意打光、没有团队簇拥，可就是这一帧，让无数网友反复放大截图。",
    content: [
      "据现场记者透露，该艺人当日结束某顶奢品牌的活动后并未直接离开，而是在后台与团队核对次日行程近四十分钟，直到凌晨才独自走向保姆车。",
      "随行视频中，他全程素颜，头发微乱却难掩优越骨相。评论区迅速被'这皮肤是认真的吗''状态比红毯还好'刷屏，相关话题阅读量一夜之间突破两亿。",
      "有造型师分析，与多数艺人追求浓妆舞台感不同，这位小生近期刻意走'去雕琢'路线，把重点放在质感与气场上，反而更贴近当下观众对真实感的偏好。",
      "知情人士透露，他接下来将无缝衔接一部现实题材电影的进组工作，预计十一月开机，目前正处于封闭围读阶段。",
      "深夜的一帧偶遇，再次印证了那句话：在聚光灯之外，真正能留住观众心的，从来是扎实的状态与真诚的营业。",
    ],
    related: ["baoliao-2026-0906-05", "baoliao-2026-0905-02", "baoliao-2026-0904-03"],
  },
  {
    id: "baoliao-2026-0906-02",
    column: "variety",
    title: "爆款音综总决赛录音棚直击，导师席一位嘉宾状态意外抢镜",
    excerpt: "本周六晚八点，热度霸榜的国民音综即将迎来收官之夜。节目组日前开放探班，多个细节引发观众猜想。",
    tag: "独家",
    author: "98综艺组",
    date: "09-06 10:05",
    readMin: 5,
    views: "41.2万",
    hot: 2,
    image:
      "https://readdy.ai/api/search-image?query=modern%20recording%20studio%20stage%20with%20vintage%20microphone%20and%20warm%20neon%20stage%20lights%20in%20pink%20and%20amber%2C%20glossy%20floor%20reflection%2C%20empty%20spotlight%2C%20atmospheric%20cinematic%20concert%20setup%2C%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=variety-01-2026&orientation=landscape",
    lead: "总决赛录制前夕，我们提前潜入录音棚。台上是反复打磨的选手，台侧却有个意想不到的'彩蛋'抢走了所有人的目光。",
    content: [
      "开放日当天，录制现场的保密工作依旧严密，但导播间的监控屏还是透露出不少信息。三位常驻导师已全部到位，唯一令现场人员意外的是飞行嘉宾席多了一位'熟面孔'。",
      "据工作人员透露，这位嘉宾并非来客串演唱，而是以'惊喜合作者'身份参与其中一组的帮唱环节。他进棚前先独自在候场区试音近一小时，专业度令全场侧目。",
      "有音乐总监点评：这场合作将是一首融合了传统与流行的全新改编，编曲推翻过四个版本，只为在总决赛舞台呈现'反差感最强'的一击。",
      "总决赛的赛制也首次向外透露——不是单一比拼，而是'团队对抗+个人突围'双阶段，节目组称这将刷新以往竞演节目的高潮体验。",
      "一切悬念，将在周六晚的直播中揭晓。而那个意外抢镜的身影，或许正是这季节目最值得期待的关键牌。",
    ],
    related: ["baoliao-2026-0906-01", "baoliao-2026-0905-04", "baoliao-2026-0903-06"],
  },
  {
    id: "baoliao-2026-0906-03",
    column: "crew",
    title: "古装大剧开机首日路透流出，主演同框默契度拉满",
    excerpt: "备受关注的S级古装大剧在横店低调开机，首日路透中两位主演的对视与动作戏细节被镜头忠实记录。",
    tag: "路透",
    author: "98剧组组",
    date: "09-06 13:40",
    readMin: 6,
    views: "28.5万",
    hot: 3,
    image:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20drama%20set%20at%20dawn%20with%20fog%20mountain%20and%20traditional%20palace%20architecture%2C%20two%20figures%20in%20flowing%20hanfu%20robes%20facing%20each%20other%2C%20warm%20golden%20hour%20light%2C%20cinematic%20epic%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=crew-01-2026&orientation=landscape",
    lead: "从筹备到开机历经一年多的古装大剧，终于在横店亮出真容。首日片场，两位主演的眼神戏与走位配合被摄影师记录，默契程度远超预期。",
    content: [
      "开机首日，横店的晨雾尚未散尽，剧组已紧锣密鼓铺开第一场重头戏。两位主演在镜头前对戏时，仅用三次走位便完成了导演要求的复杂调度。",
      "现场执行导演透露，这场戏是全剧情感线的起点，两人需要呈现'初见时的疏离与暗涌'，而他们仅凭一个抬眸就把情绪层次递进到位。",
      "服装组连日赶工还原的年代质感也在路透中展露：织金暗纹、手工盘扣与做旧配饰，细节考究程度被不少考据党称赞。",
      "除了文戏，首日还安排了短时间的武打预排。两位主演均提前进组练习武术基础，吊威亚时的稳定度让武术指导频频点头。",
      "据制片方透露，该剧将在横店与某影视基地双地取景，拍摄周期预计四个月，首轮招商已被多家平台锁定。",
    ],
    related: ["baoliao-2026-0905-01", "baoliao-2026-0906-02", "baoliao-2026-0904-02"],
  },
  {
    id: "baoliao-2026-0906-04",
    column: "schedule",
    title: "本周艺人行程表出炉：三位当红明星同日撞行程，机场或将大排长龙",
    excerpt: "艺人行程一直是粉丝最关心的话题。本周多位人气艺人通告密集，更有三位顶流同一天现身同一城市。",
    tag: "行程",
    author: "98行程组",
    date: "09-06 07:00",
    readMin: 3,
    views: "19.8万",
    image:
      "https://readdy.ai/api/search-image?query=modern%20airport%20lounge%20wide%20angle%20with%20large%20windows%20and%20departure%20screens%2C%20travelers%20silhouettes%20and%20waiting%20crowd%20with%20cameras%2C%20bright%20natural%20light%20through%20glass%2C%20clean%20minimal%20architectural%20photography%2C%20high%20detail&width=900&height=620&seq=schedule-01-2026&orientation=landscape",
    lead: "一周的通告排期，牵动着无数人的接机计划。这周的行程表信息量不小，几位人气艺人的动向尤其值得划重点。",
    content: [
      "本期行程表显示，本周六将是名副其实的'撞行程日'。三位人气艺人将先后落地同一座城市，分别参加代言站台、品牌晚宴与媒体群访。",
      "其中一位流量演员更是在一天内转场三地，上午影棚拍摄、下午新剧发布会、晚间赶赴红毯，堪称'铁人行程'。",
      "针对粉丝最关心的接机安排，多站站姐已提前放出消息并提示：由于三组航班时间接近，机场安保预计升级，建议理性追星、注意个人安全。",
      "行程组也提醒，多数公开行程为商务性质，是否开放应援以官方通知为准，谨防黄牛借机牟利。",
    ],
    related: ["baoliao-2026-0905-03", "baoliao-2026-0906-01", "baoliao-2026-0903-04"],
  },
  {
    id: "baoliao-2026-0906-05",
    column: "star",
    title: "85花晒素颜健身照状态回春，网友考古她十年前旧照感叹没差",
    excerpt: "一向低调的某85花女星罕见晒出健身照，紧致状态引发热议，评论区瞬间被'冻龄''自律'刷屏。",
    tag: "热议",
    author: "98编辑部",
    date: "09-06 16:30",
    readMin: 4,
    views: "25.4万",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20fitness%20selfie%20of%20a%20beautiful%20chinese%20actress%20in%20her%20thirties%20in%20athleisure%20gear%20at%20a%20bright%20modern%20gym%2C%20natural%20window%20light%2C%20fresh%20makeup-free%20glowing%20skin%2C%20warm%20tones%2C%20editorial%20lifestyle%20photography%2C%20high%20detail&width=900&height=620&seq=star-02-2026&orientation=landscape",
    lead: "没有精修，没有滤镜，一张素颜健身照，却让安静许久的评论区彻底沸腾。",
    content: [
      "距离上一条社交动态过去近一个月，这位85花女星终于更新了动态——一张运动后的素颜自拍，附文仅两个字'久违'。",
      "照片中她状态松弛，紧实的线条与明亮的肤色让不少网友直呼'这状态真的能打'。有粉丝随即翻出她十年前的同角度旧照对比，惊讶发现岁月在她脸上几乎'没有出手'。",
      "据其工作室人士透露，近两年她有意放慢节奏，把重心从'刷脸'转向'养状态'，每天雷打不动两小时运动，配合健康作息。",
      "业内人士评价：娱乐圈不缺漂亮，缺的是能把自律转化为持久状态的自控力。这张素颜照，恰恰是她在转型路上最有说服力的一张名片。",
    ],
    related: ["baoliao-2026-0906-01", "baoliao-2026-0906-03", "baoliao-2026-0904-05"],
  },
  {
    id: "baoliao-2026-0905-01",
    column: "crew",
    title: "悬疑网剧补拍传闻再起，制片人回应'一切以成片为准'",
    excerpt: "一部口碑悬疑剧因补拍传闻登上热搜。面对外界猜测，制片人的回应暧昧又克制，更添悬念。",
    tag: "独家",
    author: "98剧组组",
    date: "09-05 18:12",
    readMin: 5,
    views: "33.1万",
    image:
      "https://readdy.ai/api/search-image?query=dark%20moody%20film%20studio%20backlot%20at%20night%20with%20neon%20signs%20and%20rain%20wet%20concrete%2C%20suspenseful%20crime%20drama%20atmosphere%2C%20movie%20camera%20silhouette%2C%20teal%20and%20orange%20cinematic%20grade%2C%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=crew-02-2026&orientation=landscape",
    lead: "当一部被奉为'年度黑马'的悬疑剧传出补拍，真相往往比传闻更耐人寻味。",
    content: [
      "过去三天，某口碑悬疑剧将被大规模补拍的传闻持续发酵，多个版本在网络流传，从'结局重写'到'主演阵容调整'众说纷纭。",
      "面对愈演愈烈的猜测，制片人终于在采访中松口，但回应极其克制：'剧组近期确实有部分镜头需要重新打磨，但一切以成片为准。'",
      "这句话被网友逐字分析，越品越像埋了伏笔。有剧评人推测，这或许意味着第二季的铺垫，而非简单的删改。",
      "片方知情人士则透露，主创团队对第一季结局仍有执念，正在为某个关键角色的命运做更完整的表达，因此才选择精益求精。",
    ],
    related: ["baoliao-2026-0906-03", "baoliao-2026-0906-02", "baoliao-2026-0904-01"],
  },
  {
    id: "baoliao-2026-0905-02",
    column: "star",
    title: "颁奖礼后台名场面：两位影后同框互让奖杯，现场掌声雷动",
    excerpt: "一场电影盛典的后台，两位影后级前辈的谦让互动成为当晚最温暖的名场面。",
    tag: "现场",
    author: "98编辑部",
    date: "09-05 22:41",
    readMin: 4,
    views: "45.6万",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20award%20ceremony%20backstage%20with%20two%20graceful%20chinese%20actresses%20in%20evening%20gowns%20sharing%20a%20trophy%20and%20laughing%2C%20warm%20glittering%20bokeh%20lights%2C%20glamorous%20red%20carpet%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=star-03-2026&orientation=landscape",
    lead: "聚光灯给了台上的获奖者，而最动人的画面，往往发生在后台无人注目的角落。",
    content: [
      "昨晚某电影盛典落幕，除了台前的荣誉时刻，一段被镜头捕捉的后台画面在网络上悄然走红。",
      "画面中，两位影后级女演员正巧在后台通道相遇，其中一人主动将刚拿到的奖杯递向前辈，笑着说'这杯该敬您'，对方则笑着推回，两人你来我往互相谦让，最后相拥大笑。",
      "这段没有台本、没有机位刻意安排的互动，被网友评为'当晚含金量最高的名场面'。不少观众感叹：真正的尊重，从不靠言语标榜。",
      "两位当事人事后都未刻意营销此事，这种默契与克制，反而让这段佳话更显珍贵。",
    ],
    related: ["baoliao-2026-0906-05", "baoliao-2026-0906-01", "baoliao-2026-0904-04"],
  },
  {
    id: "baoliao-2026-0905-03",
    column: "schedule",
    title: "人气男团全员确认出席音乐节，压轴曲目引发粉丝竞猜",
    excerpt: "接连缺席两档节目后，人气男团终于官宣最新行程，压轴舞台的表演曲目成为粉丝讨论焦点。",
    tag: "官宣",
    author: "98行程组",
    date: "09-05 15:22",
    readMin: 3,
    views: "22.9万",
    image:
      "https://readdy.ai/api/search-image?query=energetic%20music%20festival%20main%20stage%20at%20dusk%20with%20huge%20crowd%20and%20confetti%2C%20purple%20and%20gold%20stage%20lights%2C%20boy%20band%20silhouettes%20performing%2C%20epic%20concert%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=schedule-02-2026&orientation=landscape",
    lead: "粉丝盼了半个月的'合体'，终于有了确切答案。官宣一出，评论区瞬间被'久等了'刷屏。",
    content: [
      "今日午后，人气男团官方账号更新动态，确认全员将出席下周末举办的某大型音乐节，并担纲压轴表演。",
      "这是该团体继两位成员暂别综艺录制后，首次以完整体形式公开亮相。消息一出，相关话题火速冲上热搜前排。",
      "关于压轴曲目的猜测更是五花八门：有人期待新歌首唱，有人票选经典旧作，也有人脑洞'会不会有神秘合作舞台'。",
      "经纪团队回应称，本次舞台将带来'诚意满满的特别编排'，具体内容留到现场揭晓。",
    ],
    related: ["baoliao-2026-0906-04", "baoliao-2026-0905-04", "baoliao-2026-0903-02"],
  },
  {
    id: "baoliao-2026-0905-04",
    column: "variety",
    title: "慢综艺录制地成打卡胜地，当地小吃摊意外'出圈'",
    excerpt: "一档田园慢综的取景地成为网友新晋旅行打卡地，镜头里出现的小吃摊主更因此一夜爆火。",
    tag: "热点",
    author: "98综艺组",
    date: "09-05 12:09",
    readMin: 4,
    views: "31.7万",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20rural%20village%20morning%20with%20sunrise%20over%20green%20rice%20fields%2C%20small%20traditional%20street%20food%20stall%20with%20steam%20rising%2C%20warm%20golden%20light%2C%20peaceful%20slow%20life%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=variety-02-2026&orientation=landscape",
    lead: "一档慢综艺，意外捧红了一个村、一条街、还有一位不善言辞的摊主大叔。",
    content: [
      "田园慢综的热播，让原本名不见经传的南方小村一夜之间进入大众视野。镜头里青瓦白墙、晨雾稻香，成了无数人心中'向往的生活'。",
      "更意外的是出圈的主角：节目嘉宾常去光顾的一家老式小吃摊。摊主大叔憨厚话少，却在镜头前用一碗热腾腾的招牌小吃圈粉无数。",
      "节目播出后，大批观众慕名前往打卡，摊前一度排起长队。大叔面对突如其来的流量既高兴又紧张，反复念叨'我只是做自己本分的事'。",
      "有文旅行业人士评价：好的慢综艺不是造景，而是发现生活本来的样子。这种真诚，恰恰是最难复制的内容。",
    ],
    related: ["baoliao-2026-0906-02", "baoliao-2026-0905-03", "baoliao-2026-0904-06"],
  },
  {
    id: "baoliao-2026-0904-01",
    column: "crew",
    title: "年代剧片场趣闻：老戏骨现场教学，年轻演员直呼'赚到了'",
    excerpt: "一部年代剧的片场，一场临时加戏，成了老戏骨给年轻演员上的最生动一课。",
    tag: "花絮",
    author: "98剧组组",
    date: "09-04 20:33",
    readMin: 5,
    views: "27.3万",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20chinese%20period%20drama%20set%20with%20old%20brick%20houses%20and%20hanging%20laundry%20lines%2C%20warm%20afternoon%20sunlight%2C%20film%20crew%20and%20actors%20in%201980s%20costume%20preparing%20for%20a%20scene%2C%20nostalgic%20cinematic%20photography%2C%20high%20detail&width=900&height=620&seq=crew-03-2026&orientation=landscape",
    lead: "在片场，最值钱的从来不是台词本，而是前辈愿意多说的那几句话。",
    content: [
      "某年代剧拍摄现场，原定的一场简单过场戏，因老戏骨一个'临时加戏'的提议，变成了全场年轻演员的公开课。",
      "老戏骨认为原剧本的对手戏过于'平'，建议增加一个不经意的动作细节来展现角色内心的松动。他亲自演示了三版处理方式，每一次都赢得片场由衷的掌声。",
      "合作的年轻演员事后感叹：'很多专业书上写不透的东西，前辈一个眼神就讲清楚了，这场戏真的赚到了。'",
      "业内人士表示，老戏骨与新人的良性碰撞，正是当下影视圈最需要的传承。这种真诚交流，远比流量数据更能定义一部作品的价值。",
    ],
    related: ["baoliao-2026-0906-03", "baoliao-2026-0905-01", "baoliao-2026-0906-05"],
  },
  {
    id: "baoliao-2026-0904-02",
    column: "crew",
    title: "新片官宣阵容惹期待，实力派云集被评'含金量超标'",
    excerpt: "一部现实题材电影官宣完整阵容，多位实力派演员同台，网友直呼'这配置闭眼冲'。",
    tag: "官宣",
    author: "98剧组组",
    date: "09-04 16:18",
    readMin: 4,
    views: "38.9万",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20production%20behind%20the%20scenes%20with%20clapperboard%20and%20film%20director%20chair%20on%20a%20dramatic%20moody%20film%20set%2C%20spotlight%20and%20smoke%2C%20warm%20amber%20and%20dark%20tones%2C%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=crew-04-2026&orientation=landscape",
    lead: "当片方一口气公布的主演名单里，每一位的名字都自带分量时，观众的期待值直接拉满。",
    content: [
      "今日午后，一部筹备已久的现实题材电影正式官宣主演阵容。名单上没有流量明星的堆砌，取而代之的是多位被观众认证'演技派'的中坚力量。",
      "阵容公布后，评论区的画风高度统一：'含金量超标''这配置直接闭眼冲''就冲这阵容也必须支持国产佳作'。",
      "据悉，该片改编自真实事件，聚焦一群普通人在时代浪潮中的抉择与坚守。导演在开机信中写道：'我们想拍的不是英雄，而是每个咬牙前行的普通人。'",
      "多位主演也已在第一时间进组体验生活，为角色提前做足功课，认真程度可见一斑。",
    ],
    related: ["baoliao-2026-0906-03", "baoliao-2026-0904-01", "baoliao-2026-0905-01"],
  },
  {
    id: "baoliao-2026-0904-03",
    column: "star",
    title: "国民度爆棚的童星长大成人，首次担当大女主的选角历程揭秘",
    excerpt: "从童星到大女主，这位成长于观众眼皮底下的演员，用十年时间完成蜕变。",
    tag: "深度",
    author: "98编辑部",
    date: "09-04 11:26",
    readMin: 6,
    views: "29.6万",
    image:
      "https://readdy.ai/api/search-image?query=young%20chinese%20actress%20transitioning%20from%20child%20star%20to%20lead%20role%2C%20elegant%20modern%20portrait%20in%20soft%20studio%20light%2C%20confident%20gaze%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=900&height=620&seq=star-04-2026&orientation=landscape",
    lead: "看着长大的孩子，突然成了荧幕里独当一面的主角。这份'养成系'的期待与压力，或许只有她自己最懂。",
    content: [
      "从四岁初次亮相荧幕，到如今官宣首次担当大女主，这位演员几乎是陪着整整一代观众一起长大的。",
      "新剧选角阶段，片方其实面试了上百位女演员。最终把机会交给她，导演给出的理由是：'她眼里有戏，更重要的是，她懂得珍惜。'",
      "知情人士透露，为了贴合角色，她提前数月减重并学习方言，进组前把剧本翻了近二十遍，笔记本上密密麻麻写满了角色分析。",
      "面对外界'童星能否扛起大女主'的质疑，她曾云淡风轻地回应：'我不需要向谁证明什么，作品会说话。'",
      "这场漫长的养成，即将迎来验收时刻。无论结果如何，敢于踏出舒适区本身，就值得掌声。",
    ],
    related: ["baoliao-2026-0906-01", "baoliao-2026-0906-05", "baoliao-2026-0904-05"],
  },
  {
    id: "baoliao-2026-0904-04",
    column: "star",
    title: "歌手演唱会门票三秒售罄，黄牛却票源充足引热议",
    excerpt: "一场演唱会门票上线三秒即告售罄，而二级市场却'票源充足'，背后乱象再次刺痛歌迷。",
    tag: "热议",
    author: "98编辑部",
    date: "09-04 09:15",
    readMin: 4,
    views: "52.3万",
    image:
      "https://readdy.ai/api/search-image?query=grand%20indoor%20concert%20arena%20with%20thousands%20of%20fans%20holding%20glowing%20lightsticks%2C%20singer%20on%20stage%20silhouette%2C%20dramatic%20stage%20lighting%2C%20blue%20and%20violet%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=star-05-2026&orientation=landscape",
    lead: "三秒售罄的狂欢背后，是无数人蹲守抢票却无功而返的失落，与二级市场'充足票源'的荒诞。",
    content: [
      "某实力派歌手演唱会门票今日开售，官方渠道显示三秒售罄，话题瞬间刷屏社交平台。",
      "然而与'手速大战'形成讽刺对比的是，在多个二手与代抢渠道，大量溢价票源仍在明码标价出售，价格从数倍到十余倍不等。",
      "不少抢票失利的歌迷愤愤不平：'嘴上说秒空，黄牛手里却一抓一大把。'对此，票务平台回应称已启用多重风控，但效果存疑。",
      "有行业观察者指出，票务乱象背后是技术与灰色产业链的博弈，需要平台、主办方与监管多方合力，才能真正把票还给真正想听歌的人。",
    ],
    related: ["baoliao-2026-0905-02", "baoliao-2026-0906-02", "baoliao-2026-0905-03"],
  },
  {
    id: "baoliao-2026-0904-05",
    column: "star",
    title: "老牌影帝罕见营业开直播，幽默回复笑翻全网上热搜",
    excerpt: "一向很少营业的老牌影帝开了一场直播，全程高能回应网友提问，圈粉无数。",
    tag: "直播",
    author: "98编辑部",
    date: "09-04 20:01",
    readMin: 4,
    views: "47.8万",
    image:
      "https://readdy.ai/api/search-image?query=distinguished%20older%20chinese%20actor%20in%20his%20sixties%20with%20silver%20hair%20laughing%20during%20a%20warm%20live%20stream%20in%20a%20homey%20study%2C%20soft%20warm%20lamplight%2C%20bookshelves%20background%2C%20intimate%20conversational%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=star-06-2026&orientation=landscape",
    lead: "低调了大半辈子的影帝突然开播，本想安静打招呼，结果一场直播笑料不断，直接把自己送上了热搜。",
    content: [
      "昨晚，一位素来低调的老牌影帝破天荒开了一场直播，理由是'想念大家了'。开播不到十分钟，在线人数便冲破百万。",
      "面对网友五花八门的问题，他全程淡定又不失幽默。被问及'为何不多接戏'，他笑称'得留点时间研究怎么把生活过好'；被问'最怕什么'，他一本正经答'怕你们不催我交作业'。",
      "高情商又不端着的神回复，让弹幕笑成一片，'影帝 幽默天花板''这才是真性情'等话题火速登上热搜。",
      "这场没有剧本、没有带货的直播，反而成了当晚最治愈的存在。很多网友感叹：老艺术家随口的谈吐，都是岁月给的底气。",
    ],
    related: ["baoliao-2026-0905-02", "baoliao-2026-0906-05", "baoliao-2026-0904-03"],
  },
  {
    id: "baoliao-2026-0904-06",
    column: "variety",
    title: "恋爱观察综艺官宣回归，四位素人嘉宾阵容提前被扒",
    excerpt: "曾经掀起全民讨论的恋爱观察综艺宣布回归，素人嘉宾的幕后故事先一步勾起观众好奇。",
    tag: "官宣",
    author: "98综艺组",
    date: "09-04 14:27",
    readMin: 4,
    views: "34.2万",
    image:
      "https://readdy.ai/api/search-image?query=romantic%20reality%20dating%20show%20set%20design%20with%20warm%20string%20lights%20and%20cozy%20cafe%20interior%2C%20date%20table%20with%20candles%20and%20flowers%2C%20soft%20dreamy%20evening%20atmosphere%2C%20pink%20and%20warm%20gold%20tones%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=900&height=620&seq=variety-03-2026&orientation=landscape",
    lead: "一档综艺能在收官多年后仍被反复提起，足见它的后劲。如今官宣回归，观众的期待比想象中还要热。",
    content: [
      "曾经霸榜热搜的恋爱观察类综艺正式官宣新一季回归，先导预告以'这一次，我们认真谈爱'为主题，迅速点燃观众情绪。",
      "虽然嘉宾阵容尚未官宣，但网络上已有网友根据蛛丝马迹扒出几位'疑似人选'，身份跨度从素人到小有名气的博主，讨论度居高不下。",
      "节目组回应称，本季将更聚焦真实关系中的沟通与成长，减少剧本感，努力呈现'成年人爱情该有的样子'。",
      "有业内人士认为，恋爱观察综艺长青的秘诀不在于'制造冲突'，而在于让观众在别人的故事里照见自己。这或许是它历久弥新的原因。",
    ],
    related: ["baoliao-2026-0906-02", "baoliao-2026-0905-04", "baoliao-2026-0904-02"],
  },
];

export const hotList: string[] = [
  "#顶流小生深夜收工",
  "#85花冻龄状态",
  "#音综总决赛导师",
  "#演唱会票务乱象",
  "#童星晋升大女主",
  "#恋爱观察综艺回归",
  "#古装大剧开机",
  "#影帝直播金句",
];

export const tickerList: string[] = [
  "「顶流小生深夜素颜状态」阅读量一夜破两亿",
  "音综总决赛今晚八点直播，惊喜合作者身份成谜",
  "古装S级大剧横店开机，首轮招商已被锁定",
  "本周六三位顶流撞行程，机场或将大排长龙",
  "85花素颜健身照引考古，状态十年如一日",
  "恋爱观察综艺官宣回归，素人阵容引猜测",
];

export const testimonials = [
  {
    name: "@爱吃瓜的猫",
    role: "吃瓜五年老粉",
    text: "每天通勤路上点开98爆料，几分钟就能补完全部瓜料，更新又快又准，是我追星路上的必备。",
  },
  {
    name: "@追星看海人",
    role: "偶像站姐",
    text: "艺人行程板块做得很细，接机安排和活动预告都标得清清楚楚，帮我少走了好多弯路。",
  },
  {
    name: "@老剧迷阿周",
    role: "国产剧爱好者",
    text: "剧组路透和开机消息总是比别家快半拍，看得出小编是真在关注，不是搬运二手消息。",
  },
];

export const faqs = [
  {
    q: "98爆料的娱乐新闻都是从哪里来的？",
    a: "我们坚持'多渠道信源 + 编辑核实'的采编原则。信息来源包括公开的艺人通告、影视行业正规发布会、经授权的现场拍摄，以及编辑部一线记者的一手采访，发布前会做交叉核实，确保信息真实可靠。",
  },
  {
    q: "明星动态和艺人行程为什么更新这么快？",
    a: "98爆料建有覆盖机场、活动、片场的常态化信息网络，并依托公开的通告与票务信息实时维护行程板块。工作日全天候跟进，重要瓜料第一时间推送，力求让读者在别家还没反应时就掌握动态。",
  },
  {
    q: "我看到报道有疑问，应该如何反馈或纠错？",
    a: "欢迎通过本站「关于我们」页面的联系方式与我们取得联系。若您掌握更准确的信息，可将材料发给我们，编辑部核实后会第一时间更新或更正相关内容。",
  },
  {
    q: "综艺内幕、剧组路透类内容会有夸大成分吗？",
    a: "娱乐资讯本就伴随信息差，我们始终坚持'不传谣、不造谣、标题不夸大'。凡未经证实的路透与猜测，我们都会明确标注'网传''推测'等字样，把事实与解读严格区分开。",
  },
  {
    q: "可以转载或引用98爆料的文章吗？",
    a: "欢迎在注明来源「98爆料」的前提下规范转载。出于版权保护与信息准确考量，请勿大篇幅改动原文标题及核心事实，具体转载合作可联系我们。",
  },
];